import { atom } from 'jotai';

// TODO: This atom is used to determine if the user is on the legacy end user onboarding flow,
// and should be removed when the legacy end user onboarding flow is removed.s
export const isLegacyEndUserOnboardingAtom = atom(false);
